
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"64.625","viewBox":"0 0 60 64.625"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"transform":"translate(-111.47 -91.72)"}},[_c('circle',{staticClass:"a",attrs:{"cx":"9.651","cy":"9.651","r":"9.651","transform":"translate(151.286 137.044)"}}),_c('circle',{staticClass:"a",attrs:{"cx":"9.651","cy":"9.651","r":"9.651","transform":"translate(111.47 137.044)"}}),_c('path',{staticClass:"a",attrs:{"d":"M165.952 126.031l-6.19 2.465a3.825 3.825 0 00-2.173 2.229l-1.511 4.1a15.124 15.124 0 015.516-.954l.041-.259a3.921 3.921 0 012.148-2.9l3.482-1.7a1.628 1.628 0 00-1.318-2.975zM167.29 96.884l-.013-.047a1.11 1.11 0 01.415-1.2l.8-.584-1-1.374-.8.587a1.11 1.11 0 01-1.252.037 1.942 1.942 0 00-2.189.064l-2.338 1.7.6.833a1.837 1.837 0 002.128 2.924l.6.833 2.321-1.689a1.942 1.942 0 00.734-2.094zM168.148 93.777l.442.608.662-.481-.872-.3zM170.236 93.188l-.877-.293-.594.432.871.3zM169.747 92.614l.876.293.092.24.754-.98-.325-.446-1.172.406.209.173zM170.574 122.216l-2.361-10.294-4.468-10.02a3.175 3.175 0 01-2.88-.408l-.072-.005 5.215 22.456a2.227 2.227 0 013.209.824 2.206 2.206 0 001.357-2.553zM142.404 125.925h-8.356v8.476h10.59zM150.489 153.916a13.514 13.514 0 01-1.477-11.266h-1.071l-1.154-4.6h-12.738v4.549h-1.02a13.507 13.507 0 01-1.46 11.318z"}})])])
          )
        }
      }
    